import { admin2 } from '@/api/instance'

// ANCHOR Banner
export const GetBanner = async ({
  type,
  start,
  limit,
}) => {
  return await admin2({
    method: 'get',
    url: '/ohbotBanner',
    params: {
      type,
      start,
      limit,
    },
  })
}

export const GetBannerCount = async ({
  type,
}) => {
  return await admin2({
    method: 'get',
    url: '/ohbotBanner/count',
    params: {
      type,
    },
  })
}

export const FindBanner = async ({
  id,
}) => {
  return await admin2({
    method: 'get',
    url: `/ohbotBanner/${id}`,
  })
}

// ANCHOR FAQ
export const GetHelpQA = async ({
  question,
  start,
  limit,
}) => {
  return await admin2({
    method: 'get',
    url: '/helpQA',
    params: {
      question,
      start,
      limit,
    },
  })
}

export const GetHelpQACount = async ({
  question,
}) => {
  return await admin2({
    method: 'get',
    url: '/helpQA/count',
    params: {
      question,
    },
  })
}

export const FindHelpQA = async ({
  id,
}) => {
  return await admin2({
    method: 'get',
    url: `/helpQA/${id}`,
  })
}

// ANCHOR announcement
/**
 * 取得公告列表 admin.ohbotNews.find
 * @param {Object} params - 查詢參數
 * @param {string} [params.title] - 公告標題
 * @param {string} [params.type] - 公告類型 ('shop_home' 或 'partner')
 * @param {number} [params.start=0] - 查詢起始位置
 * @param {number} [params.limit=10] - 查詢筆數
 * @returns {import('@/api/instance').Api2Response<Array>} 公告列表
 */
export const GetAnnouncement = async ({
  title,
  type,
  start,
  limit,
}) => {
  return await admin2({
    method: 'get',
    url: '/ohbotNews',
    params: {
      title,
      type,
      start,
      limit,
    },
  })
}

/**
 * 取得公告總數 admin.ohbotNews.count
 * @param {Object} params - 查詢參數
 * @param {string} [params.title] - 公告標題
 * @param {string} [params.type] - 公告類型 ('shop_home' 或 'partner')
 * @returns {import('@/api/instance').Api2Response<{ count: number }>} 公告總數 { count: number }
 */
export const GetAnnouncementCount = async ({
  title,
  type,
}) => {
  return await admin2({
    method: 'get',
    url: '/ohbotNews/count',
    params: {
      title,
      type,
    },
  })
}

export const FindAnnouncement = async ({
  id,
}) => {
  return await admin2({
    method: 'get',
    url: `/ohbotNews/${id}`,
  })
}
// ANCHOR 教學手冊
export const GetHandbook = async ({
  name,
  start,
  limit,
}) => {
  return await admin2({
    method: 'get',
    url: '/helpFile',
    params: {
      name,
      start,
      limit,
    },
  })
}

export const GetHandBookCount = async ({
  name,
}) => {
  return await admin2({
    method: 'get',
    url: '/helpFile/count',
    params: {
      name,
    },
  })
}

export const FindHandBook = async ({
  id,
}) => {
  return await admin2({
    method: 'get',
    url: `/helpFile/${id}`,
  })
}

export const GetHandBookFileDownloadLink = async ({
  id,
}) => {
  return await admin2({
    method: 'get',
    url: `/helpFile/${id}/getFileSignedUrlExpireUrl`,
  })
}
